import { render } from "./PartnerListView.vue?vue&type=template&id=564f72b0&scoped=true"
import script from "./PartnerListView.vue?vue&type=script&lang=js"
export * from "./PartnerListView.vue?vue&type=script&lang=js"

import "./PartnerListView.vue?vue&type=style&index=0&id=564f72b0&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564f72b0"]])

export default __exports__